import { AccomodationTranslation } from "./accomodation-translation.model";
import { Location } from "./location.model";
export class AccomodationTranslationLocation{
    location?:Location;
    accomodationTranslationDto?: AccomodationTranslation;
    
    constructor(
        location?: Location,
        accomodationTranslationDto?: AccomodationTranslation
    ){
        this.location = location;
        this.accomodationTranslationDto = accomodationTranslationDto;
    }
}